/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SomniaSearchHandlerInfo = {
    ID: SomniaSearchHandlerInfo.ID;
    SRLIST: Record<string, any>;
};

export namespace SomniaSearchHandlerInfo {

    export enum ID {
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        PROJECT = 'PROJECT',
        TOKEN = 'TOKEN',
    }


}

